'use strict';

var React = require('react');
var Spinner = require('../Icons/Spinner');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".loading-module_loading-ring__QpEas {\n  display: inline-block;\n}\n\n.loading-module_loading-dots__3mDhV {\n  color: #8a8f9c;\n  font-size: 25px;\n  font-weight: normal;\n}\n.loading-module_loading-dots__3mDhV:hover {\n  cursor: default;\n  text-decoration: none;\n}\n.loading-module_loading-dots__3mDhV:after {\n  animation: loading-module_dots__3OOoN 1s steps(5, end) infinite;\n  content: \".\";\n  margin-left: 1px;\n}\n@keyframes loading-module_dots__3OOoN {\n  0%, 20% {\n    color: rgba(0, 0, 0, 0);\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  40% {\n    color: #8a8f9c;\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  60% {\n    text-shadow: 0.25em 0 0 #8a8f9c, 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n  80%, 100% {\n    text-shadow: 0.25em 0 0 #8a8f9c, 0.5em 0 0 #8a8f9c;\n  }\n}\n\n.loading-module_spinnerContainer__2wkkj {\n  position: relative;\n  min-width: 48px;\n  min-height: 48px;\n}\n.loading-module_spinnerContainer__2wkkj .loading-module_spinner__1q1Hm {\n  position: absolute;\n  display: block;\n  width: 48px;\n  height: 48px;\n  border: 8px solid #e9e9e9;\n  border-top: 8px solid #d63426;\n  border-radius: 50%;\n  animation: loading-module_rotateSpinner__2Hwl1 ease-out 0.69s infinite;\n}\n@keyframes loading-module_rotateSpinner__2Hwl1 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}";
var styles = {"loading-ring":"loading-module_loading-ring__QpEas","loading-dots":"loading-module_loading-dots__3mDhV","dots":"loading-module_dots__3OOoN","spinnerContainer":"loading-module_spinnerContainer__2wkkj","spinner":"loading-module_spinner__1q1Hm","rotateSpinner":"loading-module_rotateSpinner__2Hwl1"};
styleInject(css_248z,{"insertAt":"top"});

const sizes = {
    sm: '25px',
    md: '34px',
    lg: '44px'
};
const Loading = (_a) => {
    var { className = '', color = '#d63426', size = 'md', type = 'ring' } = _a, rest = __rest(_a, ["className", "color", "size", "type"]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const loadingSize = sizes[size] || size; // can be 'sm', 'md', 'lg' or a pixel size
    const dotStyle = {
        color,
        fontSize: `${loadingSize}`
    };
    const ringClassNameWrapper = `${styles['loading-ring']} ${className}`.trim();
    const dotsClassNameWrapper = `${styles['loading-dots']} ${className}`.trim();
    if (type === 'dots') {
        return React__default['default'].createElement("div", Object.assign({ className: dotsClassNameWrapper, style: dotStyle }, rest));
    }
    return (React__default['default'].createElement("div", Object.assign({ className: ringClassNameWrapper }, rest),
        React__default['default'].createElement(Spinner__default['default'], { strokeColor: color, width: loadingSize, height: loadingSize, "data-testid": "spinner" })));
};
var index = React.memo(Loading);

module.exports = index;
